<!-- 
    input输入框 
    author:xxk 
    https://element.eleme.cn/#/zh-CN/component/input
    图标通过插槽注入
 -->
<template>
  <el-input class="AppInput-root" :style="styles" ref="AppInputRef" v-model="valueModel" v-bind="inputPropsResult" 
  @clear="$emit('clear',$event)" @input="$emit('input',$event)" @keyup.enter.native="$emit('enter',$event)" @focus="$emit('focus',$event)" @blur="$emit('blur',$event)">
    <!-- 默认显示的插槽 -->
    <template v-if="iconProps.prependName" slot="prepend">
      <i :class="iconProps.prependName"></i>
    </template>
    <template v-if="iconProps.appendName" slot="append">
      <el-button><i :class="iconProps.appendName"></i></el-button>
    </template>
    <!-- 各插槽中转 -->
    <template v-for="name in Object.keys($slots)" #[name]>
      <slot :name="name"></slot>
    </template>
  </el-input>
</template>
<script>
  import {vModel} from '@/mixins/vModel.js';
  export default {
    name:'AppInput',
    mixins:[vModel],
    props: {
      // input组件传参
      inputProps: { type: Object, default() { return {}; } },
      // 图标选项
      iconProps: { type: Object, default() { return { prependName: '', appendName:'' }; } },
      // 样式
      styles: { type: Object, default() { return {}; } },
    },
    computed:{
      // 组件属性合并结果
      inputPropsResult(){
        return Object.assign(
          {
            placeholder: '请输入',
            clearable: true,
            get showPassword() {
              return this.type === 'password';
            },
          },
          this.$attrs,
          this.inputProps,
        );
      }
    },
  };
</script>
<style scoped lang="less">
  .AppInput-root{ 
    &.el-textarea{ height: auto; }
    & /deep/{
      .el-input-group__append, .el-input-group__prepend{ background-color: transparent; }
      .el-input__suffix { display: flex; align-items: center; }
    }
  }
</style>
